<!-- <h2 mat-dialog-title>Install Angular</h2> -->
<mat-dialog-content class="mat-typography">
  <!-- [src]=" link  | safeUrl" -->
  <!-- src="https://player.vimeo.com/video/286898202\" -->
  <iframe
    [src]=" 'https://player.vimeo.com/video/'+name  | safeUrl"
    width="560"
    height="315"
    frameborder="0"
    title="My video"
    webkitallowfullscreen
    mozallowfullscreen
    allowfullscreen
  ></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
  <!-- <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button> -->
</mat-dialog-actions>

<!-- Copyright 2020 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
